import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { type } from 'arktype'

import { PlatformProductDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-product-documentation-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

/** Lets a documentation link be shared as e.g. `?product=mrpw`; an unrecognized slug is stripped, not an error. */
const searchSchema = type({ 'product?': 'string' })

const ProductDocumentationRoute = () => {
  const { product } = Route.useSearch()
  const navigate = useNavigate()
  return (
    <PermissionChecker requiredPermissions={['documentation.read']}>
      <PlatformProductDocumentationPage
        productParam={product}
        onProductChange={(newProduct) =>
          void navigate({ to: '.', search: { product: newProduct ?? undefined }, replace: true })
        }
      />
    </PermissionChecker>
  )
}

export const Route = createFileRoute('/bo/documentation/products')({
  validateSearch: searchSchema,
  component: ProductDocumentationRoute,
})
